import { ComparisonOperator } from "@evergis/ui";

export const OPERATOR_CONDITION_REMAP: Record<ComparisonOperator, string> = {
  [ComparisonOperator.Equals]: "==",
  [ComparisonOperator.NotEquals]: "!=",
  [ComparisonOperator.GreaterThan]: ">",
  [ComparisonOperator.GreaterOrEquals]: ">=",
  [ComparisonOperator.LessThan]: "<",
  [ComparisonOperator.LessOrEquals]: "<=",
  [ComparisonOperator.Filled]: "!=",
  [ComparisonOperator.Empty]: "==",
  [ComparisonOperator.Contains]: "==",
  [ComparisonOperator.NotContains]: "!=",
  [ComparisonOperator.StartsWith]: "==",
  [ComparisonOperator.NotStartsWith]: "!=",
  [ComparisonOperator.EndsWith]: "==",
  [ComparisonOperator.NotEndsWith]: "!=",
  [ComparisonOperator.Between]: "between",
  [ComparisonOperator.Outside]: "!between",
};
